export default "__VITE_ASSET__CQvt_DdO__"